<script setup>
// import Modal from '@/components/core/Modal.vue'

// refs
const visible = ref(false)
const message = ref('')

const show = (text = 'das ist ein error') => {
  message.value = text
  visible.value = true
}
const hide = () => { visible.value = false }

defineExpose({ show, hide })
</script>

<template>
  <Dialog
    v-model:visible="visible" name="errorModal"
    :modal="true"
    :closable="false"
    class="w-md-50 w-100 m-4"
  >
    <template #header>
      <div class="fw-bold fs-4">
        <i class="fas fa-exclamation-circle" />
        <span>&nbsp;Error</span>
      </div>
    </template>
    <div class="modal-body text-center">
      <h2 class="m-1">
        {{ message }}
      </h2>
    </div>
    <template #footer>
      <Button class="flex-grow-1 p-3 justify-content-center text-white" size="large" severity="warn" type="button" @click="hide">
        Close
      </Button>
    </template>
  </Dialog>
</template>
